import { render, staticRenderFns } from "./operLog.vue?vue&type=template&id=085a1651"
import script from "./operLog.vue?vue&type=script&lang=js"
export * from "./operLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports